<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2021 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->

<ng-container *ngIf="(vm$ | async) as vm">
    <div class="position-relative d-flex flex-column table-body-wrapper">
        <table cdk-table [dataSource]="config.dataSource" [trackBy]="trackRecord"
               aria-describedby="table-body"
               class="list-view-table striped-table table">

            <ng-container cdkColumnDef="checkbox" *ngIf="vm.selection">

                <th cdk-header-cell scope="col" *cdkHeaderCellDef class="primary-table-header"></th>

                <td cdk-cell *cdkCellDef="let record">
                    <label class="checkbox-container">
                        <input type="checkbox"
                               [checked]="(record['id'] && vm.selected[record['id']]) || allSelected(vm.selectionStatus) "
                               (change)="toggleSelection(record['id'])"
                               [disabled]="allSelected(vm.selectionStatus)"
                               aria-hidden="true">
                        <span class="checkmark"></span>
                    </label>
                </td>

            </ng-container>

            <ng-container cdkColumnDef="show-more" *ngIf="popoverColumns && popoverColumns.length">

                <th cdk-header-cell scope="col" *cdkHeaderCellDef class="primary-table-header show-more-column"></th>

                <td cdk-cell *cdkCellDef="let record" class="show-more-column">
                    <scrm-record-details-popup-button [record]="record" [columns]="popoverColumns"
                                                      *ngIf="popoverColumns.length"></scrm-record-details-popup-button>
                </td>

            </ng-container>

            <ng-container *ngFor="let column of vm.columns" [cdkColumnDef]="column.name">

                <th cdk-header-cell
                    *cdkHeaderCellDef
                    scope="col"
                    [class]="('primary-table-header ' + 'column-' + column?.name ?? '') + ' ' + ('column-type-' + column?.type ?? '')">

                    <scrm-label [labelKey]="column.label" [module]="config.module || ''"></scrm-label>
                    <scrm-sort-button *ngIf="config.sort$ && column.sortable"
                                      [state]="getFieldSort(column)"
                                      [readonly]="column?.sortReadOnly ?? false"
                    >
                    </scrm-sort-button>

                </th>

                <td cdk-cell *cdkCellDef="let record" [class]="('column-' + column?.name ?? '') + ' ' + ('column-type-' + column?.type ?? '')">
                    <scrm-field [mode]="'list'"
                                [type]="column.type"
                                [field]="getField(column, record)"
                                [record]="record">
                    </scrm-field>
                </td>

            </ng-container>

            <ng-container cdkColumnDef="line-actions">

                <th cdk-header-cell scope="col" *cdkHeaderCellDef class="primary-table-header"></th>

                <td cdk-cell *cdkCellDef="let record">
                    <scrm-line-action-menu *ngIf="record && config.lineActions"
                                           [config]="config.lineActions"
                                           [activeLineAction]="activeLineAction"
                                           [record]="record"
                                           [wrapperClass]="'listview-actions'"
                                           [klass]="'icon-bar'">
                    </scrm-line-action-menu>
                </td>

            </ng-container>

            <tr cdk-header-row *cdkHeaderRowDef="vm.displayedColumns"></tr>
            <tr cdk-row *cdkRowDef="let row; columns: vm.displayedColumns;"></tr>

        </table>

        <div *ngIf="!vm.loading && vm.records.length === 0">
            <p class="lead text-center pt-3">
                <scrm-label labelKey="MSG_LIST_VIEW_NO_RESULTS_BASIC"></scrm-label>
            </p>
        </div>
        <div *ngIf="vm.loading" [class.m-5]="!vm.records || vm.records.length === 0">
            <scrm-loading-spinner [overlay]="true"></scrm-loading-spinner>
        </div>
    </div>
</ng-container>
